import React, { useState, useEffect } from 'react';
import './SelectVideoType.scss';
import { video_type_images } from '@/assets/imageReferences.js';
import { getVideoTypes } from '@/features/systemManagement/videoType/videoTypeService.js';
import { DIGITAL_HUMAN_TYPES } from '@/constants/constants.js';

// 动态视频数据（从服务器加载）
export let videoData = [];

/**
 * 更新视频数据
 * @param {Array} serverData 从服务器获取的视频数据
 */
export const updateVideoData = (serverData) => {
  videoData = serverData;
};

function SelectVideoType({ formik }) {
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [displayData, setDisplayData] = useState([]);

  // 组件挂载时加载视频数据
  useEffect(() => {
    const loadVideoData = async () => {
      try {
        const types = await getVideoTypes();
        updateVideoData(types);
        setDisplayData(videoData);
      } catch (error) {
        console.error('Failed to load video types:', error);
        // 加载失败时显示空
        setDisplayData([]);
      }
    };

    loadVideoData();
  }, []);

  const handleSelect = (video) => {
    setSelectedCardId(video.id);
    formik.setFieldValue('videoType', video.title);
    formik.setFieldValue('videoTypeId', video.id);
  };

  return (
    <div className="video-cards-container">
      {displayData.map((type) => (
        <div
          key={type.id}
          className={`video-card ${selectedCardId === type.id ? 'selected' : ''}`}
          onClick={() => handleSelect(type)}
        >
          {selectedCardId === type.id && <i className="bi bi-check2-circle"></i>}

          {video_type_images[type.img_key] && (
            <div className="videoCard-show-container">
              <img src={video_type_images[type.img_key]} alt={type.title} />
            </div>
          )}

          <div
            className="videoCard-header-container"
            style={{ marginTop: !video_type_images[type.img_key] && ` 48px` }}
          >
            <h5>
              {type.title}
            </h5>
            <div className="btns-container">
              <button
                onClick={() => handleSelect(type)}
                className={`btn ${
                  selectedCardId === type.id
                    ? 'btn-primary'
                    : 'btn-outline-primary'
                }`}
              >
                {selectedCardId === type.id ? '已选择' : '选择'}
              </button>
            </div>
          </div>
          {type.title !== '电影级定制' ? (
            <div className="videoCard-description-container">
              {type.video_length && (
                <div className="no-wrap">视频时长: {type.video_length}分钟</div>
              )}
              {type.note && type.total_images && (
                <div className="no-wrap">图片总数: {type.total_images}</div>
              )}
              {type.static_photos && (
                <div className="no-wrap">
                  静态照片数量: {type.static_photos}
                </div>
              )}
              {type.subtitle_required && type.subtitle_word_count && (
                <div className="no-wrap">字幕: {type.subtitle_word_count}</div>
              )}{' '}
              {type.voice_reproduction && (
                <div className="no-wrap ">
                  声音处理:{' '}
                  <span className="hint-text">
                    {type.voice_reproduction_type
                      ? type.voice_reproduction_type
                      : '有'}
                  </span>
                </div>
              )}{' '}
              {(!type.note && type.text_word_count) && (
                <div className="no-wrap">
                  文案:{' '}
                  <span className="hint-text">{type.text_word_count}</span>
                </div>
              )}
              {type.dynamic_photos && (
                <div className="no-wrap">
                  {!type.note ? 'AI动态生成影像照片数量' : '动态化照片'}:{' '}
                  <span className="hint-text">{type.dynamic_photos}</span>
                </div>
              )}
              {type.ai_person_scene_fusion_time && (
                <div className="no-wrap">
                  AI人物场景融合视频时长:{' '}
                  <span className="hint-text">
                    {type.ai_person_scene_fusion_time} 分钟
                  </span>
                 
                </div>
              )}
              {type.ai_movie_level_scene_fusion_time && (
                <div className="no-wrap">
                  AI电影级分镜人物影像视频时长:{' '}
                  <span className="hint-text">
                    {type.ai_movie_level_scene_fusion_time}
                  </span>
                  分钟
                </div>
              )}
              {type.digital_human_has && (
                <div className="no-wrap">
                  {type.digital_human_type}
                  {type.digital_human_type === DIGITAL_HUMAN_TYPES.WAVE
                    ? (type.digital_human_wave_time ? `:${type.digital_human_wave_time}分钟` : '')
                    : type.digital_human_type === DIGITAL_HUMAN_TYPES.ORIGINAL_VOICE
                    ? (type.digital_human_farewell_time ? `:${type.digital_human_farewell_time}分钟` : '')
                    : ''}
                </div>
              )}
              {/* {type.modification_times && (
                <div className="no-wrap">
                  修改次数: {type.modification_times}次
                </div>
              )} */}
            </div>
          ) : (
            <div className="videoCard-description-container">
              <div className="no-wrap">视频时长: 8分钟起</div>
              <div className="no-wrap">
                客户素材不限，商业影视级制作内容，依次交付：
              </div>
              <div className="no-wrap">分镜稿</div>
              <div className="no-wrap">分镜demo样片</div>
              <div className="no-wrap">初稿完整影片</div>
              <div className="no-wrap">终稿完整影片</div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default SelectVideoType;
